export default __webpack_public_path__ + "static/media/about-team-member-1.071ab2db.jpg";